import { readServerTimeDifference } from './useServerTime';

const useDateNow = () => {
  return () => Date.now() + readServerTimeDifference();
};

export default useDateNow;
